export default __webpack_public_path__ + "static/media/candlestick patterns.f731363f.svg";